import {Action, ShippingInfoState} from './types'
import React from "react";

export const setShippingInfo = (shippingInfo: ShippingInfoState) => ({
    type: 'SET_SHIPPING_INFO',
    payload: {shippingInfo}
})

const shippingInfoReducer: React.Reducer<ShippingInfoState, Action> = (state: ShippingInfoState, action: Action) => {
    switch (action.type) {
        case 'SET_SHIPPING_INFO':
            return {...action.payload.shippingInfo}
        default:
            return state
    }
}

export default shippingInfoReducer
